import React, { useState } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { FaPhoneVolume } from 'react-icons/fa6';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../Assets/LOGO_CFCAE.png';

const Navbar = () => {
	const [nav, setNav] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	const handleNav = () => setNav(!nav);

	// Fonction de défilement générique
	const scrollToElement = (id) => {
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	};

	// Clic sur ACCUEIL : Remonte tout en haut
	const handleHomeClick = (e) => {
		setNav(false);
		if (location.pathname !== '/') {
			navigate('/');
			window.scrollTo({ top: 0, behavior: 'smooth' });
		} else {
			e.preventDefault();
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	};

	// Clic sur RÉFÉRENCES ou CONTACT
	const handleSectionClick = (e, targetId) => {
		e.preventDefault();
		setNav(false);
		if (location.pathname !== '/') {
			navigate('/');
			setTimeout(() => {
				scrollToElement(targetId);
			}, 200);
		} else {
			scrollToElement(targetId);
		}
	};

	return (
		<div className='z-50 fixed top-0 left-0 w-full select-none bg-white shadow-lg'>
			<div className='w-[80%] flex justify-between h-20 sm:h-28 mx-auto px-4 max-h-[1240px] items-center'>
				{/* Logo : Clic pour remonter en haut de l'accueil */}
				<Link to='/' onClick={handleHomeClick}>
					<img src={logo} alt='CFCAE Logo' className='w-16 sm:w-32 h-auto' />
				</Link>

				{/* Navigation Desktop */}
				<div className='hidden md:flex font-bold items-center'>
					<Link
						to='/'
						onClick={handleHomeClick}
						className='relative p-4 cursor-pointer text-black hover:text-[#87152B] transition-colors duration-300 group'
					>
						<span>ACCUEIL</span>
						<div className='absolute bottom-0 left-0 w-0 h-[4px] bg-[#AC9961] transition-all duration-300 ease-in-out group-hover:w-full'></div>
					</Link>

					<Link
						to='/formations'
						className='relative p-4 cursor-pointer text-black hover:text-[#87152B] transition-colors duration-300 group'
					>
						<span>FORMATIONS</span>
						<div className='absolute bottom-0 left-0 w-0 h-[4px] bg-[#AC9961] transition-all duration-300 ease-in-out group-hover:w-full'></div>
					</Link>

					<Link
						to='/domaines'
						className='relative p-4 cursor-pointer text-black hover:text-[#87152B] transition-colors duration-300 group'
					>
						<span>DOMAINES</span>
						<div className='absolute bottom-0 left-0 w-0 h-[4px] bg-[#AC9961] transition-all duration-300 ease-in-out group-hover:w-full'></div>
					</Link>

					{/* Bouton RÉFÉRENCES */}
					<a
						href='#references'
						onClick={(e) => handleSectionClick(e, 'references')}
						className='relative p-4 cursor-pointer text-black hover:text-[#87152B] transition-colors duration-300 group'
					>
						<span>RÉFÉRENCES</span>
						<div className='absolute bottom-0 left-0 w-0 h-[4px] bg-[#AC9961] transition-all duration-300 ease-in-out group-hover:w-full'></div>
					</a>

					{/* Bouton CONTACT */}
					<a
						href='#contact'
						onClick={(e) => handleSectionClick(e, 'contact')}
						className='relative p-4 cursor-pointer text-black hover:text-[#87152B] transition-colors duration-300 group'
					>
						<span>CONTACT</span>
						<div className='absolute bottom-0 left-0 w-0 h-[4px] bg-[#AC9961] transition-all duration-300 ease-in-out group-hover:w-full'></div>
					</a>

					<div className='ml-6 flex flex-row items-center justify-start text-lg font-semibold gap-1 text-black hover:text-[#87152B] transition-colors duration-300'>
						<FaPhoneVolume size={20} />
						<div className='select-text text-black hover:text-[#87152B] transition-colors duration-300 ml-2 text-xs flex flex-col items-center justify-start'>
							<span>+212 529061623</span>
							<span>+212 600997544</span>
						</div>
					</div>
				</div>

				{/* Bouton Menu Burger Mobile */}
				<div
					onClick={handleNav}
					className='block w-[20px] h-[20px] md:hidden z-50 cursor-pointer'
				>
					{nav ? (
						<AiOutlineClose size={20} className='text-[#87152B]' />
					) : (
						<AiOutlineMenu size={20} className='text-[#87152B]' />
					)}
				</div>

				{/* Navigation Mobile */}
				<div
					className={`fixed h-full w-[60%] bg-white border-r border-r-[#AC9961] ease-in-out duration-1000 z-50 ${
						nav ? 'left-0 top-0' : 'left-[-100%]'
					}`}
				>
					<Link to='/' onClick={handleHomeClick}>
						<img src={logo} alt='CFCAE Logo' className='pl-5 w-32 h-auto mt-4' />
					</Link>
					<ul className='uppercase p-4'>
						<li className='font-semibold hover:text-[#87152B] border-b-4 border-b-[#87152B] hover:border-b-[#AC9961]'>
							<Link to='/' className='block p-4 w-full h-full' onClick={handleHomeClick}>
								ACCUEIL
							</Link>
						</li>
						<li className='font-semibold hover:text-[#87152B] border-b-4 border-b-[#87152B] hover:border-b-[#AC9961]'>
							<Link to='/formations' className='block p-4 w-full h-full' onClick={() => setNav(false)}>
								FORMATIONS
							</Link>
						</li>
						<li className='font-semibold hover:text-[#87152B] border-b-4 border-b-[#87152B] hover:border-b-[#AC9961]'>
							<Link to='/domaines' className='block p-4 w-full h-full' onClick={() => setNav(false)}>
								DOMAINES
							</Link>
						</li>
						<li className='font-semibold hover:text-[#87152B] border-b-4 border-b-[#87152B] hover:border-b-[#AC9961]'>
							<a
								href='#references'
								className='block p-4 w-full h-full'
								onClick={(e) => handleSectionClick(e, 'references')}
							>
								RÉFÉRENCES
							</a>
						</li>
						<li className='font-semibold hover:text-[#87152B]'>
							<a
								href='#contact'
								className='block p-4 w-full h-full'
								onClick={(e) => handleSectionClick(e, 'contact')}
							>
								CONTACT
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};

export default Navbar;